export default class EntryFieldCheckbox {
	constructor(element) {
		this.element = element;
		this.data = this.element.dataset;
		['invalid', 'change'].forEach(event => {
			this.element.addEventListener(
				event,
				() => this._set_validity()
			);
		})

		this.observer = new MutationObserver(
			(mutationList, observer) => this._set_validity()
		);

		this.observer.observe(this.element, { attributes: true });
	}

	_set_validity() {
		let validity = '';
		if (
			this.data.customValidity &&
				this.element.validity.valueMissing
		) {
			validity = this.data.customValidity;
		}

		this.element.setCustomValidity(validity);
	}
}

